module.exports = __webpack_public_path__ + "img/icon-location-open.53402442.svg";